/* Cart – cross-sell variatie bridge (enable checkbox + attrs) */
export function mount() {
  if (!window.jQuery) return;
  const $doc = window.jQuery(document);

  $doc.on('found_variation', 'form.wk-xvar', function (_evt, variation) {
    const $form = window.jQuery(this);
    const $card = $form.closest('[data-wk-xs-card]');
    const $chk  = $card.find('.wk-xs-check__input');

    if (variation && variation.variation_id) {
      $chk.prop('disabled', false)
          .attr('data-variation-id', variation.variation_id)
          .data('attrs', getAttrsFromForm($form));
    }
  });

  $doc.on('reset_data hide_variation', 'form.wk-xvar', function () {
    const $form = window.jQuery(this);
    const $card = $form.closest('[data-wk-xs-card]');
    const $chk  = $card.find('.wk-xs-check__input');
    $chk.prop('disabled', true)
        .removeAttr('data-variation-id')
        .removeData('attrs');
  });

  function getAttrsFromForm($form) {
    const out = {};
    $form.find('select[name^="attribute_"]').each(function(){
      const name = this.name;
      const val  = window.jQuery(this).val();
      if (val) out[name] = val;
    });
    return out;
  }
}
